import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.cloudcom.com.br',
});

export default api;